export const ORDER_STATUS = {
  new: { label: "طلب جديد", color: "#3B82F6" },
  accepted: { label: "تم القبول", color: "#F59E0B" },
  preparing: { label: "جاري التجهيز", color: "#F59E0B" },
  ready: { label: "جاهز للاستلام", color: "#10B981" },
  delivering: { label: "جاري التوصيل", color: "#10B981" },
  completed: { label: "مكتمل", color: "#10B981" },
  rejected: { label: "مرفوض", color: "#EF4444" },
  cancelled: { label: "ملغي", color: "#EF4444" },
};

export const PAYMENT_STATUS = {
  cod: { label: "دفع عند الاستلام", color: "#10B981" },
  pending: { label: "بانتظار الدفع", color: "#F59E0B" },
  paid: { label: "مدفوع إلكترونيًا", color: "#10B981" },
  failed: { label: "فشل الدفع", color: "#EF4444" },
};

export const PaymentBadge = ({ order }) => {
  const key = order.payment_status || (order.payment_method === "online" ? "pending" : "cod");
  const p = PAYMENT_STATUS[key] || { label: key, color: "#94A3B8" };
  return (
    <span className="inline-flex items-center gap-1.5 rounded-lg px-2 py-1 text-[11px] font-bold"
      style={{ backgroundColor: `${p.color}22`, color: p.color }}>
      {p.label}
      {order.tap_charge_id && <span className="text-[var(--text-subtle)] font-normal">· {order.tap_charge_id}</span>}
    </span>
  );
};

export const StatusBadge = ({ status }) => {
  const s = ORDER_STATUS[status] || { label: status, color: "#94A3B8" };
  return (
    <span className="inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1 text-xs font-bold"
      style={{ backgroundColor: `${s.color}22`, color: s.color }}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: s.color }} />
      {s.label}
    </span>
  );
};
